<script>
    import addVariant from "src/utility/variant";

    export let variant;
    export let label;
    export let messages = [];
</script>

<div class="pc__form-group" use:addVariant={variant}>
    {#if label}
    <!-- svelte-ignore a11y-label-has-associated-control -->
    <label class="pc__form-group__label" use:addVariant={variant}>{label}</label>
    {/if}

    <slot></slot>

    {#if messages.length > 0}
    <ul class="pc__form-group__messages">
        {#each messages as message}
        <li class={message.status}>{message.text}</li>
        {/each}
    </ul>
    {/if}
</div>